/**
 * Truncate a whiteboard play json to remove unnecessary data.
 * The data that will be removed are:
 *  - removeTextbox
 *  - Duplicate setTextboxPosition, only the final one will be used
 * @param json
 * @returns {*}
 */
export function truncateJson(json) {
    // Anything put into removeSet will not be included into the final JSON
    const removeSet = new Set();
    // This is to keep the latest movement information for a particular textbox
    const moveSet = {};
    const resizeSet = {};

    let content = json.map((step, index) => {
        const svgId = step.d[0];
        if (
            svgId &&
            svgId.startsWith &&
            typeof svgId.startsWith === "function" &&
            (svgId.startsWith("tx") || svgId.length === 36)
        ) {
            if (step.t === "removeTextbox" || step.t === "removeEmbed") {
                removeSet.add(step.d[0]);
            } else if (
                step.t === "setTextboxPosition" ||
                step.t === "setEmbedPosition"
            ) {
                moveSet[step.d[0]] = step;
            } else if (step.t === "setEmbedSize") {
                resizeSet[step.d[0]] = step;
            }
        }
        return step;
    });
    content = content.filter((step) => {
        return !removeSet.has(step.d[0]) && !removeSet.has(step.d[5]);
    });

    // Remove all setTextboxPosition, we will add them later below
    content = content.filter((step) => {
        return ![
            "setTextboxPosition",
            "setEmbedPosition",
            "setEmbedSize",
        ].includes(step.t);
    });
    // loop through remove set and remove moveSet and resizeSet entry based on the key
    removeSet.forEach((key) => {
        delete moveSet[key];
        delete resizeSet[key];
    });
    content.push(...Object.values(moveSet));
    content.push(...Object.values(resizeSet));
    return content;
}
